export default __webpack_public_path__ + "static/media/You_Won_3_2.767e7821.gif";